// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qpPjz","importantInfo":"styles_importantInfo__2Eku-"};